module.exports = __webpack_public_path__ + "static/media/jpx.34498706.svg";